howspace.securitySettings = (() => {
    'use strict';

    const ip4ToInt = (ip) => {
        // Cannot use arrow functions, because IE11 does NOT support them :(
        //return ip.split('.').reduce((int, oct) => (int << 8) + parseInt(oct, 10), 0) >>> 0;

        // Same code written with regular functions instead.
        return ip.split('.').reduce(function(int, oct) {
            return (int << 8) + parseInt(oct, 10);
        }, 0) >>> 0;
    }

    const isIp4InCidr = (ip, cidr) => {
        const arr = cidr.split('/');
        let bits = 32;
        let range = arr[0];

        if(arr.length > 1) {
            bits = arr[1];
        }

        // Cannot use ** "exponentiation operator", because IE11 does not support it.
        //mask = ~(2 ** (32 - bits) - 1);

        // Same code written in ES5 aka IE11 compatible way.
        // 2 ** 3 is same as Math.pow(2,3)
        const mask = ~(Math.pow(2, (32 - bits) - 1));

        return (ip4ToInt(ip) & mask) === (ip4ToInt(range) & mask);
    };

    const getCsvValue = val => {
        if (Array.isArray(val)) {
            // Value is already an array.
            return val;
        }

        if (typeof val === 'string') {
            // Split the comma separated string into array, trim each value and filter only non-empty values.
            return val.split(',').map(item => { return item.trim(); }).filter(item => { return item !== '' });
        }

        // For all other types (undefined etc) we return an empty array.
        return [];
    };

    const initSecuritySettings = (securitySettings) => {
        real.autosize.init(securitySettings);

        securitySettings.find('.login-link-limit-use-radio').on('change', function(e) {
            if(securitySettings.find('#security-settings-login-link-max-use-count-limited').prop('checked')) {
                let input = securitySettings.find('#security-settings-login-link-max-use-count-input');
                input.val(Math.max(input.val(), 1));
                securitySettings.find('#security-settings-login-link-max-use-count-form-group').removeClass('d-none').velocity('stop').velocity('slideDown', {
                    duration : 'fast',
                    complete : function() {
                        $(this).removeAttr('style').show();
                    }
                });
            } else {
                securitySettings.find('#security-settings-login-link-max-use-count-form-group').velocity('stop').velocity('slideUp', {
                    duration : 'fast',
                    complete : function() {
                        $(this).removeAttr('style').hide();
                    }
                });
            }
        });

        // IP address list validation.
        securitySettings.find('#security-settings-allowed-ip-addresses-input').on('input', real.input.validateIpList);
        securitySettings.find('#security-settings-allowed-ip-addresses-input').on('blur', real.input.validateIpListBlur);

        // If user removes own IP require confirmation upon save.
        securitySettings.find('#security-settings-allowed-ip-addresses-input').on('input blur', function(e) {
            let clientIpFound = false;
            const input = $(this);
            const clientIp = input.data('client-ip-address');

            if(!clientIp) {
                return;
            }

            input.val().split(',').forEach(function(cidr) {
                if(isIp4InCidr(clientIp, cidr)) {
                    clientIpFound = true;
                }
            });

            if(input.val().trim() !== '' && !clientIpFound) {
                input.addClass('confirm-remove-own-ip-address-on-save');
            } else {
                input.removeClass('confirm-remove-own-ip-address-on-save');
            }
        });

        securitySettings.find('.ip-restriction-radio').on('change', function(e) {
            if(securitySettings.find('#security-settings-ip-restriction-defined-addresses').prop('checked')) {
                securitySettings.find('#security-settings-ip-restriction-defined-addresses-form-group').removeClass('d-none').velocity('stop').velocity('slideDown', {
                    duration : 'fast',
                    complete : function() {
                        $(this).removeAttr('style').show();
                        real.input.focus(securitySettings.find('#security-settings-allowed-ip-addresses-input'));
                    }
                });
            } else {
                securitySettings.find('#security-settings-ip-restriction-defined-addresses-form-group').velocity('stop').velocity('slideUp', {
                    duration : 'fast',
                    complete : function() {
                        $(this).removeAttr('style').hide();
                    }
                });
            }
        });

        securitySettings.find('.login-link-nonrestricted-radio').on('change', function(e) {
            const extraForm = $('#security-settings-login-links-defined-addresses-form-group');
            if (e.target.value === 'on') {
                extraForm.addClass('d-none');
            }
        });

        securitySettings.find('.login-link-restricted-radio').on('change', function(e) {
            const extraForm = $('#security-settings-login-links-defined-addresses-form-group');
            if (e.target.value === 'on') {
                extraForm.removeClass('d-none');
            }
        });

        securitySettings.find('.allow-all-csp-sources-checkbox').on('change', e => {
            const checkbox = $(e.target);
            const wrapper = checkbox.closest('.whitelisted-sources-wrapper');
            if (checkbox.prop('checked')) {
                wrapper.find('.whitelisted-sources').addClass('d-none');
            } else {
                wrapper.find('.whitelisted-sources').removeClass('d-none');
            }
        });

        securitySettings.find('.add-whitelisted-source-btn').on('click', function(e) {
            const btn = $(this);
            const wrapper = btn.closest('.whitelisted-sources-wrapper');
            const template = wrapper.find('.whitelisted-source-template');

            btn.before(template.html());

            const source = wrapper.find('.whitelisted-source').last();
            const textarea = source.find('textarea');
            textarea.attr('name', textarea.data('name'));
            textarea.removeDataAndAttr('name');

            const options = {
                duration : 'fast',
                complete : function() {
                    source.removeAttr('style');
                    textarea.addClass('autosize');
                    real.autosize.init(source);
                    real.input.focus(textarea);
                }
            }
            if (getComputedStyle(source[0]).display === 'flex') {
                options.display = 'flex';
            }
            source.hide().velocity('slideDown', options);

            howspace.manager.setModified();
        });

        securitySettings.on('click', '.delete-white-listed-src-btn', function(e) {
            const btn = $(this);
            const source = btn.closest('.whitelisted-source');

            real.button.loading(btn, source);

            source.velocity('slideUp', {
                duration : 'fast',
                complete : function() {
                    source.remove();
                }
            });

            howspace.manager.setModified();
        });

        securitySettings.on('blur', '.allowed-source-input', function(e) {
            const input = $(this);
            const val = input.val().trim().replace(/\n/g, '');

            if(input.val() !== val) {
                input.val(val);
                real.autosize.update(input);
            }
        });

        securitySettings.on('input', '.allowed-source-input', function(e) {
            $(this).removeClass('is-invalid');
        });

        securitySettings.find('input[min]').on('blur input change', real.input.validateMin);
    }

    return {

        init : (elem) => {
            elem.findIncludingSelf('.howspace-security-settings:not(.howspace-security-settings-initialized)').each(function() {
                const securitySettings = $(this);

                securitySettings.addClass('howspace-security-settings-initialized');

                initSecuritySettings(securitySettings);
            });
        },

        destroy : (elem) => {
            elem.findIncludingSelf('.howspace-security-settings.howspace-security-settings-initialized').each(function() {
                const securitySettings = $(this);

                securitySettings.removeClass('howspace-security-settings-initialized');

                real.autosize.destroy(securitySettings);

                // Remove all event handlers and data.
                securitySettings.findIncludingSelf('*').off().removeData();
            });
        },

        getDataPayload : (securitySettings) => {
            let dataPayload = {}, propertyName;

            propertyName = securitySettings.data('property-name');
            dataPayload = real.form.getDataPayload(securitySettings);

            if(securitySettings.find('#security-settings-login-link-max-use-count-unlimited').prop('checked')) {
                dataPayload[propertyName].how_many_times_invitation_loginlink_can_be_used = 0;
            }

            if(typeof dataPayload[propertyName].ip_filters !== 'undefined') {
                if(securitySettings.find('#security-settings-ip-restriction-any-address').prop('checked')) {
                    dataPayload[propertyName].ip_filters = [];
                } else {
                    dataPayload[propertyName].ip_filters = dataPayload[propertyName].ip_filters
                        .split(',')
                        .map(function(ip) {
                            return ip.trim();
                        })
                        .filter(function(ip) {
                            return ip !== '';
                        })
                    ;
                }
            }

            if(typeof dataPayload[propertyName].allowed_email_domains_which_can_register === 'undefined') {
                dataPayload[propertyName].allowed_email_domains_which_can_register = '';
            }

            if(typeof dataPayload[propertyName].allowed_email_domains_which_can_register === 'string') {
                dataPayload[propertyName].allowed_email_domains_which_can_register = dataPayload[propertyName].allowed_email_domains_which_can_register.split(',')
                    .map(function (domain) {
                        return domain.trim().replace(/@/, '');
                    })
                    .filter(function (domain) {
                        return domain !== '';
                    })
                ;
            }

            // Handle the comma separated values.
            [
                'enforce_sso_for_emails',
                'limit_sso_to_emails',
                'limit_sso_to_organizations',
                'limit_sso_to_groups',
                'limit_sso_to_roles',
            ].forEach(setting => {
                dataPayload[propertyName][setting] = getCsvValue(dataPayload[propertyName][setting]);
            });

            return dataPayload;
        }

    };

})();
